// extracted by mini-css-extract-plugin
module.exports = {"title":"category-title-module--title--1ceAS","separator":"category-title-module--separator--36KWp","desc":"category-title-module--desc--1qWPz"};